import { useRBACStore } from "../zustand/useRBACStore";
import { useGuard } from "../hooks/useGuard";

export default function RBACMenuGuard({ children, allowedUserTypes, requiredPermission }) {
  const { isAllowedUserTypes, hasPermission } = useGuard();
  const { currentProfile } = useRBACStore();

  if (!isAllowedUserTypes(allowedUserTypes, currentProfile?.profileType, currentProfile?.role) || !hasPermission(requiredPermission, currentProfile?.profileType, currentProfile?.permissions)) {
    return null;
  }

  return children;
}
